import React, { useEffect, useRef } from 'react';

import { ThemeProvider, useTheme } from 'styled-components';
import { ThemeType } from 'theme/theme';

import useCompanyConfiguration from 'hooks/useCompanyConfiguration';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { ToastNeutral, ToastError } from './styles';

export interface ToastProps {
  type: 'success' | 'danger' | 'warning';
  noButton?: boolean;
  message: string;
  remove: () => void;
}

const Toast = ({ message, remove, type, noButton }: ToastProps) => {
  const { t } = useStoreTranslation();
  const removeRef = useRef<() => void>(remove);
  const theme = useTheme() as ThemeType;
  const companyConfiguration = useCompanyConfiguration();
  theme.primaryBackgroundColor = companyConfiguration?.primaryBackgroundColor ?? 'green';
  theme.primaryColor = companyConfiguration?.primaryColor ?? '#fff';
  theme.secondaryBackgroundColor = companyConfiguration?.secondaryBackgroundColor ?? 'red';
  theme.secondaryColor = companyConfiguration?.secondaryColor ?? '#fff';

  useEffect(() => {
    const duration = 6000;
    const id = setTimeout(() => removeRef.current(), duration);

    return () => clearTimeout(id);
  }, []);

  if (type === 'danger')
    return (
      <ThemeProvider theme={theme}>
        <ToastError>
          <ToastError.Icon alt="error-icon" src="/corporate/images/toast-icon-error.svg" />
          <ToastError.Message>{message}</ToastError.Message>
          {!noButton && <ToastError.Button onClick={remove}>{t('toast.close')}</ToastError.Button>}
        </ToastError>
      </ThemeProvider>
    );

  return (
    <ThemeProvider theme={theme}>
      <ToastNeutral>
        {type === 'success' && <ToastNeutral.SuccessIcon />}
        {type === 'warning' && <ToastNeutral.WarningIcon />}
        <ToastNeutral.Message>{message}</ToastNeutral.Message>
        {!noButton && <ToastNeutral.Button onClick={remove}>{t('toast.close')}</ToastNeutral.Button>}
      </ToastNeutral>
    </ThemeProvider>
  );
};

export default Toast;
